import { useMemo, useState } from "react";
import { Box, Divider, IconButton, List, ListItemButton, ListItemText, TextField, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function PageList({ pages, selectedPage, onSelect, onAddPageOpen }) {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return pages;
    return pages.filter((p) => {
      const name = (p.page_name || "").toLowerCase();
      const desc = (p.page_description || "").toLowerCase();
      return name.includes(needle) || desc.includes(needle);
    });
  }, [q, pages]);

  return (
    <Box className="flex flex-col">
      <Box className="flex items-center justify-between px-2 py-1">
        <strong>Pages</strong>
        <Tooltip title="Ajouter une page">
          <IconButton size="small" onClick={onAddPageOpen}>
            <AddIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ px: 1, pb: 1 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Rechercher une page…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </Box>
      <Divider />

      <List dense className="flex flex-col overflow-auto" style={{ maxHeight: "calc(100vh - 220px)" }}>
        {filtered.map((page) => (
          <ListItemButton
            key={page._id}
            onClick={() => onSelect(page)}
            selected={page.page_name === selectedPage?.page_name}
          >
            <ListItemText primary={page.page_name} secondary={page.page_description} />
          </ListItemButton>
        ))}
        {!filtered.length && (
          <Box className="px-3 py-2 text-sm text-gray-500">Aucun résultat</Box>
        )}
      </List>
    </Box>
  );
}
